const PageTypes = {
    RATES: 'rates',
    HOME: 'home',
    CALCULATOR: 'calculator',
    EDUCATION: 'education',
    BLOG: 'blog',
};

export default PageTypes;
